"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goLive = exports.activate = exports.getAccountById = exports.getTransfersByReceiver = exports.getTransfersBySender = exports.getApprovalsByUser = exports.rejectApprovals = exports.acceptApprovals = exports.getTransferById = exports.submitTransfer = exports.trust = exports.expressTransfer = exports.transfer = exports.addGiftCard = exports.addBadge = exports.addCertificate = void 0;

var axios_1 = __importDefault(require("axios"));

var constants_1 = require("../constants");

function addCertificate(certificate) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = certificate;
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronTokenLambda + "/tokens/certificate", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_1 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.addCertificate = addCertificate;

function addBadge(badge) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = badge;
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronTokenLambda + "/tokens/badge", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_2 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.addBadge = addBadge;

function addGiftCard(giftCard) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_3;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = giftCard;
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronTokenLambda + "/tokens/giftcard", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_3 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.addGiftCard = addGiftCard;

function transfer(transferModel) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_4;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = transferModel;
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronTokenLambda + "/transfers", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_4 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.transfer = transfer;

function expressTransfer(transferModel) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_5;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = transferModel;
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronTokenLambda + "/expressTransfer", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_5 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.expressTransfer = expressTransfer;

function trust(trustModel) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_6;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = trustModel;
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronTokenLambda + "/trust", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_6 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.trust = trust;

function submitTransfer(transferModel) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_7;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = transferModel;
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronTokenLambda + "/transfers/submit", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_7 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.submitTransfer = submitTransfer;

function getTransferById(id) {
  return __awaiter(this, void 0, void 0, function () {
    var res, err_8;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , axios_1.default.get(constants_1.niftronTokenLambda + "/transfers/" + id, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.data];

        case 2:
          err_8 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.getTransferById = getTransferById;

function acceptApprovals(id, approval) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_9;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = approval;
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronTokenLambda + "/approvals/" + id + "/accept", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_9 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.acceptApprovals = acceptApprovals;

function rejectApprovals(id, reject) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_10;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = reject;
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronTokenLambda + "/approvals/" + id + "/reject", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_10 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.rejectApprovals = rejectApprovals;

function getApprovalsByUser(id, limit, page) {
  return __awaiter(this, void 0, void 0, function () {
    var query, res, err_11;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          query = "";

          if (limit > 0 && page > 0) {
            query += "limit=" + limit + "&page=" + page;
          }

          return [4
          /*yield*/
          , axios_1.default.get(constants_1.niftronTokenLambda + "/users/" + id + "/approvals?" + query, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.data];

        case 2:
          err_11 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.getApprovalsByUser = getApprovalsByUser;

function getTransfersBySender(id, limit, page) {
  return __awaiter(this, void 0, void 0, function () {
    var query, res, err_12;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          query = "";

          if (limit > 0 && page > 0) {
            query += "limit=" + limit + "&page=" + page;
          }

          return [4
          /*yield*/
          , axios_1.default.get(constants_1.niftronTokenLambda + "/transfers/" + id + "/sender?" + query, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.data];

        case 2:
          err_12 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.getTransfersBySender = getTransfersBySender;

function getTransfersByReceiver(id, limit, page) {
  return __awaiter(this, void 0, void 0, function () {
    var query, res, err_13;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          query = "";

          if (limit > 0 && page > 0) {
            query += "limit=" + limit + "&page=" + page;
          }

          return [4
          /*yield*/
          , axios_1.default.get(constants_1.niftronTokenLambda + "/transfers/" + id + "/receiver?" + query, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.data];

        case 2:
          err_13 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.getTransfersByReceiver = getTransfersByReceiver;

function getAccountById(id) {
  return __awaiter(this, void 0, void 0, function () {
    var res, err_14;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , axios_1.default.get(constants_1.niftronUserLambda + "/users/" + id, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.data.data];

        case 2:
          err_14 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.getAccountById = getAccountById;

function activate(userPublicKey, merchantPublicKey, xdr) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_15;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = {
            userPublicKey: userPublicKey,
            merchantPublicKey: merchantPublicKey,
            xdr: xdr
          };
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronUserLambda + "/users/activate", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_15 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.activate = activate;

function goLive(userPublicKey, merchantPublicKey, xdr) {
  return __awaiter(this, void 0, void 0, function () {
    var postBody, res, err_16;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          postBody = {
            userPublicKey: userPublicKey,
            merchantPublicKey: merchantPublicKey,
            xdr: xdr
          };
          return [4
          /*yield*/
          , axios_1.default.post(constants_1.niftronUserLambda + "/users/goLive", postBody, {
            headers: {
              "Content-Type": "application/json"
            }
          })];

        case 1:
          res = _a.sent();

          if (res == null) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , res.status];

        case 2:
          err_16 = _a.sent();
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.goLive = goLive;